import * as Cesium from 'cesium';
import styled from 'styled-components';
import React, { useEffect } from 'react';
import CodeIcon from '@mui/icons-material/Code';
import useViewerStore from '../../store-zustand/viewer';

const Slider = styled.div`
    position: absolute;
    left: 50%;
    top: 0;
    height: calc(100% - 34.8px);
    width:0;

    &:hover {
        cursor: ew-resize;
    }
`;

const CompareSlider = () => {
    const { viewer } = useViewerStore();

    useEffect(() => {
        if (!viewer) return;
        
        var slider = document.getElementById("slider");
        viewer.scene.splitPosition = slider.offsetLeft / slider.parentElement.offsetWidth;
        var handler = new Cesium.ScreenSpaceEventHandler(slider);
        var moveActive = false;

        function move(movement) {
            if (!moveActive) {
                return;
            }

            var relativeOffset = movement.endPosition.x;
            var splitPosition =
                (slider.offsetLeft + relativeOffset) /
                slider.parentElement.offsetWidth;
            if (splitPosition < 0) {
                splitPosition = 0;
            } else if (splitPosition > 1) {
                splitPosition = 1;
            }
            slider.style.left = 100.0 * splitPosition + "%";
            viewer.scene.splitPosition = splitPosition;
        }

        handler.setInputAction(function () { moveActive = true }, Cesium.ScreenSpaceEventType.LEFT_DOWN);
        handler.setInputAction(function () { moveActive = true }, Cesium.ScreenSpaceEventType.PINCH_START);
        handler.setInputAction(move, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        handler.setInputAction(move, Cesium.ScreenSpaceEventType.PINCH_MOVE);
        handler.setInputAction(function () { moveActive = false }, Cesium.ScreenSpaceEventType.LEFT_UP);
        handler.setInputAction(function () { moveActive = false }, Cesium.ScreenSpaceEventType.PINCH_END);
    }, [viewer])

    return (
        <Slider id="slider">
            <div style={{ position: 'absolute', top: 0, backgroundColor: 'white', width: 1, height: 'calc(50% - 22px)' }} />
            <div style={{ position: 'absolute', top: 'calc(50% - 22px)', left: -22 }}>
                <svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" width='44' >
                    <circle cx="22" cy="22" r="21.5" fill="rgba(255, 255, 255, 0.25)" stroke="white" />
                    <CodeIcon width="24" x="10" />
                </svg>
            </div>
            <div style={{ position: 'absolute', backgroundColor: 'white', width: 1, top: 'calc(50% + 22px)', height: 'calc(50% - 22px)' }} />
        </Slider>
    )
}

export default CompareSlider;